import { axiosInstance } from "@/lib/api/client";

export const getCompanies = async ({
  page = "",
  pagination = true,
  type = "",
}) =>
  axiosInstance
    .get("/companies", {
      params: {
        page,
        pagination,
        type,
      },
    })
    .then((response) => response.data);
